module.exports = __webpack_public_path__ + "static/media/low-poly.9f21686c.png";